import { ELinks } from '@sharedInterfaces/globalEnums';
import { getLanguageTexts } from '@sharedInterfaces/Language/languageHelper';
import { BoxButton, BoxButtons } from '@src/App/Components/Buttons/BoxButton/BoxButton';
import InnerLayout from '@src/App/Components/Core/Layouts/InnerLayout/InnerLayout';
import type { AppState } from '@store/store';
import React from 'react';
import { useSelector } from 'react-redux';

/**
 * Represents the DocumentationPage component.
 *
 * @returns {JSX.Element} The JSX element for the DocumentationPage.
 */
export default function DocumentationPage() {
    const lang = useSelector((state: AppState) => state.employee.language);
    const langStrings = getLanguageTexts(lang).restDocu;
    return (
        <InnerLayout title={langStrings.oftenUsed.documentation}>
            <div className="page">
                <BoxButtons>
                    <BoxButton
                        title={langStrings.title}
                        description={langStrings.learnHowToUseRestApi}
                        onClick={`/${ELinks.DOCUMENTATION_REST}`}
                    />
                </BoxButtons>
            </div>
        </InnerLayout>
    );
}
